import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HomePage } from '../pages/home/home';
@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  // rootPage:any = HomePage;
  rootPage:any = "ImportPage";

  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();
      // console.log("YOU ARE A TECHIE AND LOVE LOOP DANCE? Send us a message if you want to help improve Loop Dance or found a bug.")
      console.log("%cYOU ARE A TECHIE AND LOVE LOOP DANCE?! %cSend us a message if you want to help improve Loop Dance or found a bug.", "color: red; font-size:30px;", "color: orange; font-size:16px;");
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts